// Caricamento lazy di reCAPTCHA v3. Lo script viene iniettato lato client al primo
// utilizzo (post-idratazione): il form è un'isola interattiva, nessun impatto su SSG/GEO.
// Se VITE_RECAPTCHA_SITE_KEY non è configurata, getRecaptchaToken ritorna undefined e
// il backend usa il MockRecaptchaClient (dev).

const SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string | undefined

declare global {
  interface Window {
    grecaptcha?: {
      ready: (cb: () => void) => void
      execute: (siteKey: string, options: { action: string }) => Promise<string>
    }
  }
}

let scriptPromise: Promise<void> | null = null

function loadScript(siteKey: string): Promise<void> {
  if (scriptPromise) return scriptPromise
  scriptPromise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`
    script.async = true
    script.defer = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('Impossibile caricare reCAPTCHA'))
    document.head.appendChild(script)
  })
  return scriptPromise
}

/**
 * Token reCAPTCHA v3 per l'action indicata, o undefined se la site key non è
 * configurata (in tal caso il backend bypassa la verifica con il mock).
 */
export async function getRecaptchaToken(action: string): Promise<string | undefined> {
  if (!SITE_KEY) return undefined
  await loadScript(SITE_KEY)
  const grecaptcha = window.grecaptcha
  if (!grecaptcha) return undefined
  await new Promise<void>((resolve) => grecaptcha.ready(resolve))
  return grecaptcha.execute(SITE_KEY, { action })
}
